import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };
};

export const getFamilies = async () => {
    const response = await axios.get(`${API_URL}/families`, getAuthHeaders());
    return response.data;
};

export const getFamily = async (id) => {
    const response = await axios.get(`${API_URL}/families/${id}`, getAuthHeaders());
    return response.data;
};

export const createFamily = async (familyData) => {
    const response = await axios.post(`${API_URL}/families`, familyData, getAuthHeaders());
    return response.data;
};

export const updateFamily = async (id, familyData) => {
    const response = await axios.put(`${API_URL}/families/${id}`, familyData, getAuthHeaders());
    return response.data;
};

export const deleteFamily = async (id) => {
    const response = await axios.delete(`${API_URL}/families/${id}`, getAuthHeaders());
    return response.data;
};

export const getFamilyMembers = async (id) => {
    const response = await axios.get(`${API_URL}/families/${id}/members`, getAuthHeaders());
    return response.data;
};

export const addFamilyMember = async (id, memberData) => {
    const response = await axios.post(`${API_URL}/families/${id}/members`, memberData, getAuthHeaders());
    return response.data;
};

export const removeFamilyMember = async (familyId, userId) => {
    const response = await axios.delete(`${API_URL}/families/${familyId}/members/${userId}`, getAuthHeaders());
    return response.data;
};

export const getMyFamily = async () => {
    const response = await axios.get(`${API_URL}/me/family`, getAuthHeaders());
    return response.data;
};
